import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnDestroy, Output } from '@angular/core';
import * as _ from 'lodash-es';
import { ActionButtonEvent, Badge, ColorTag, Currency, DateObject, Icon, OrderItem, Percentage, Status } from '~core/models';
import { isColorDark } from '~core/utils/utility-functions';

/**
 * Commponent for table rows
 */
@Component({
  selector: '[app-table-row]',
  templateUrl: './table-row.component.html',
})
export class TableRowComponent implements OnDestroy {
  public isDark: boolean;
  @Input() public keys: Array<Array<any>> = [];
  @Input() public columns: Array<string> = [];
  @Input() public rowData: any;
  @Input() public actionButtons: Array<any> = [];
  @Input() public smallTable: boolean = false;

  @Output() public rowButtonClickEvent: EventEmitter<any> = new EventEmitter<any>();

  constructor(@Inject(LOCALE_ID) public locale: any) { }

  public ngOnDestroy(): void { }

  /**
   * Retrieves the string path
   */
  public getData(path: string): any {
    return _.get(this.rowData, path, '');
  }

  /**
   * Triggers when row button is clicked
   */
  public rowButtonClick(element: any, buttonType: string): void {
    const rowButton: ActionButtonEvent<any> = { data: element, type: buttonType };
    this.rowButtonClickEvent.emit(rowButton);
  }

  /**
   * Checks if type is a date
   */
  public isDate(value: any): boolean {
    return value instanceof DateObject;
  }

  /**
   * Checks if type is a date
   */
  public isPercentage(value: any): boolean {
    return value instanceof Percentage;
  }

  /**
   * Checks if type is an array;
   */
  public isArray(value: any): boolean {
    return value instanceof Array;
  }

  /**
   * Checks if type is an array;
   */
  public isIcon(value: any): boolean {
    return value instanceof Icon;
  }

  /**
   * Checks if type is a currency;
   */
  public isCurrency(value: any): boolean {
    return value instanceof Currency;
  }

  /**
   * Checks if type is a status;
   */
  public isStatus(value: any): boolean {
    return value instanceof Status;
  }

  /**
   * Checks if type is a dabge;
   */
  public isBadge(value: any): boolean {
    return value instanceof Badge;
  }

  /**
   * Checks if type is a order item;
   */
  public isOrderItem(value: any): boolean {
    return value[0] instanceof OrderItem;
  }

  /**
   * Checks if type is a color;
   */
  public isColor(value: any): boolean {
    const regex = new RegExp('^#(?:[0-9a-fA-F]{3}){1,2}$');
    if (regex.test(value)) {
      this.isDark = isColorDark(value);
      return true;
    } else {
      return false;
    }
  }

  /**
   * Checks if type is a color;
   */
  public isColorTag(value: any): boolean {
    if (value instanceof ColorTag) {
      this.isDark = isColorDark(value.color);
      return true;
    } else {
      return false;
    }
  }

  /**
   * Checks the type of cell
   */
  // eslint-disable-next-line complexity
  public getCellType(value: any): string {
    if (this.isDate(value)) {
      return 'date';
    }
    if (this.isPercentage(value)) {
      return 'percentage';
    }
    if (this.isCurrency(value)) {
      return 'currency';
    }
    if (this.isStatus(value)) {
      return 'status';
    }
    if (this.isIcon(value)) {
      return 'icon';
    }
    if (this.isColor(value)) {
      return 'color';
    }
    if (this.isColorTag(value)) {
      return 'colorTag';
    }
    if (this.isBadge(value)) {
      return 'badge';
    }
    if (this.isArray(value)) {
      if (this.isOrderItem(value)) {
        return 'orderItem';
      }
      return 'array';
    }

    return 'string';
  }

  /**
   * Checks if the action button is a boolean or object and then return a boolean value
   */
  public checkDisabledActionButton(actionButtonValue: boolean | any): boolean {
    if (typeof actionButtonValue === 'boolean') {
      return actionButtonValue;
    } else if (typeof actionButtonValue === 'object') {
      if (typeof actionButtonValue?.value === 'string' || typeof actionButtonValue?.value === 'boolean') {
        if (this.rowData[actionButtonValue?.key].value) {
          return this.rowData[actionButtonValue?.key].value === actionButtonValue?.value;
        } else {
          return this.rowData[actionButtonValue?.key] === actionButtonValue?.value;
        }
      } else {
        return actionButtonValue.value(_.get(this.rowData, actionButtonValue?.key));
      }
    } else if (typeof actionButtonValue === 'string') {
      const data = this.rowData[actionButtonValue];
      if (Array.isArray(data)) {
        return data.length ? false : true;
      }
      if (typeof data === 'boolean') {
        return data;
      }
      return !data;
    }
  }
}
